// `display` is reactive — it re-evaluates whenever `root[stateKey]` changes.
// We piggy-back on that to detect open/close transitions and sync the URL:
// snapshot `location.href` on open, restore it on close. Any page-level hash
// sync (e.g. calendar.js's `_writeHash` poll) converges on the same result —
// if the modal's state is null again, that page's hash writer won't re-add a
// modal marker, so the restore sticks.
// Tracks the currently-open modal element so a global Escape listener can
// close it without each modal needing its own keyboard handler. Shared
// across all Modal instances by intent — only one modal is open at a time
// in practice, and the most-recently-opened wins if stacking ever occurs.
let _topModalEl = null
if (typeof window !== 'undefined' && !window.__modalEscBound) {
  window.__modalEscBound = true
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !_topModalEl) return
    const el = _topModalEl
    const sk = typeof el.stateKey === 'string' ? el.stateKey : null
    const root = el.state?.root
    if (!sk || !root?.update) return
    const extra =
      el.extraClose && typeof el.extraClose === 'object' && !Array.isArray(el.extraClose)
        ? el.extraClose
        : null
    root.update(extra ? { [sk]: null, ...extra } : { [sk]: null })
    e.preventDefault()
  })
}

// `display` is reactive — it re-evaluates whenever `root[stateKey]` changes.
// We piggy-back on that to detect open/close transitions: snapshot URL on
// open, restore on close, and track the top modal for Escape-to-close.
const _syncUrl = (el, isOpen) => {
  if (typeof window === 'undefined') return
  if (isOpen === el._wasOpen) return
  if (isOpen) {
    el._urlBeforeOpen = window.location.href
    _topModalEl = el
  } else {
    if (el._urlBeforeOpen && el._urlBeforeOpen !== window.location.href) {
      window.history.replaceState(null, '', el._urlBeforeOpen)
    }
    el._urlBeforeOpen = null
    if (_topModalEl === el) _topModalEl = null
  }
  el._wasOpen = isOpen
}

export const ModalFooter = {
  padding: 'A1 0 0 0'
}

export const Modal = {
  display: (el, s) => {
    const isOpen = !!s.root?.[el.stateKey]
    _syncUrl(el, isOpen)
    return isOpen ? 'flex' : 'none'
  },
  position: 'fixed',
  inset: '0',
  zIndex: '2000',
  align: 'center center',
  background: 'black.45',
  backdropFilter: 'blur(4px)',
  padding: 'A',

  onClick: (e, el, s) => {
    if (e.target !== el.node) return
    const root = s?.root
    const sk = typeof el.stateKey === 'string' ? el.stateKey : null
    if (!sk || !root?.update) return
    const extra =
      el.extraClose && typeof el.extraClose === 'object' && !Array.isArray(el.extraClose)
        ? el.extraClose
        : null
    root.update(extra ? { [sk]: null, ...extra } : { [sk]: null })
  },

  Window: {
    extends: 'ModalWindow',
    ModalHeader: {}
  }
}
